// src/App.js
import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="background"></div>
      <div className="container">
        <h1>Terms of Service for Folivana Audio</h1>
        <p>Last updated: 19 Jan 2025</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By using Folivana Audio ("the Bot"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Bot.</p>

        <h2>2. Description of Service</h2>
        <p>Folivana Audio is a Discord bot that provides music playback and related features within Discord servers. The Bot's functionality is subject to change without notice.</p>

        <h2>3. User Conduct</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Bot for any unlawful purpose or in violation of any Discord policies</li>
          <li>Attempt to gain unauthorized access to the Bot's systems or related infrastructure</li>
          <li>Use the Bot to distribute spam, malware, or other malicious content</li>
          <li>Interfere with or disrupt the integrity or performance of the Bot</li>
        </ul>

        <h2>4. Intellectual Property</h2>
        <p>All rights, title, and interest in and to the Bot, including all associated intellectual property rights, are and will remain with Folivana Audio. You may not modify, adapt, or create derivative works based on the Bot without explicit permission.</p>

        <h2>5. Disclaimer of Warranties</h2>
        <p>The Bot is provided "as is" without warranty of any kind. We disclaim all warranties, express or implied, including but not limited to the implied warranties of merchantability and fitness for a particular purpose.</p>

        <h2>6. Limitation of Liability</h2>
        <p>In no event shall Folivana Audio be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Bot.</p>

        <h2>7. Modifications to the Service</h2>
        <p>We reserve the right to modify or discontinue, temporarily or permanently, the Bot or any features or portions thereof without prior notice.</p>

        <h2>8. Termination</h2>
        <p>We may terminate or suspend your access to the Bot immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms of Service.</p>

        <h2>9. Governing Law</h2>
        <p>These Terms shall be governed and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions.</p>

        <h2>10. Changes to Terms</h2>
        <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. It is your responsibility to review these Terms periodically for changes.</p>

        <h2>11. Contact Us</h2>
        <p>If you have any questions about these Terms, please contact us at: <a href='https://discord.gg/HYrhjHgFgQ'>Support Server</a></p>
      </div>
    </div>
  );
}

export default App;
